module.exports = __webpack_public_path__ + "img/dwnld-uld.20697a89.svg";